<template>
  <section v-loading.fullscreen.lock="loading" class="library">
    <com-tabs
      :list="libraryInfo.obj.tabs"
      class="library-tabs"
      :default-tab="activeTab"
      direction="column"
      @change="changeTab"
    >
      <template v-slot:text="{ obj }">
        <div
          :class="{ activeTab: activeTab == obj.key }"
          class="library-tabs-item"
        >
          {{ obj.name }}
        </div>
      </template>
    </com-tabs>
    <div class="libraryContent">
      <com-file v-if="activeTab == 0" />
      <com-declare v-if="activeTab == 1" :school-types="schoolTypes" />
      <com-contrast
        v-if="activeTab == 2"
        :school-types="schoolTypes"
        :areas="areas"
      />
    </div>
  </section>
</template>

<script>
import comTabs from '@/components/comTabs'
import comFile from './details/comFile/index.vue'
import comDeclare from './details/comDeclare/index.vue'
import comContrast from './details/comContrast/index.vue'
import mock from '@/utils/mock'
import { mapGetters } from 'vuex'
export default {
  components: {
    comTabs,
    comFile,
    comDeclare,
    comContrast
  },
  data() {
    return {
      activeTab: 0,
      libraryInfo: mock.library.library.viewInfo,
      libraryInit: mock.library.library.init,
      loading: false,
      schoolTypes: null,
      areas: null
    }
  },
  created() {},
  mounted() {
    this.init()
  },
  methods: {
    changeTab(x, y) {
      this.activeTab = x
    },
    async init() {
      this.schoolTypes = await this.libraryInit.conditions()
      this.areas = await this.libraryInit.areas()
      console.log(this.areas)
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user'
    })
  }
}
</script>
<style scoped lang="scss">
.library {
  // @include fun-layout(1);
  display: flex;
  justify-content: center;
  // width: 66%;
  height: 100%;
  min-height: 100%;
  margin: 0 auto;
  padding-top: 20px;
  &-tabs {
    display: flex;
    flex-direction: column;
    margin-right: 18px;
    position: fixed;
    top: 92px;
    left: 20px;
    &-item {
      text-align: center;
      font-size: 14px;
      color: #333;
      line-height: 50px;
      width: 140px;
      cursor: pointer;
      margin-bottom: 2px;
    }
    .activeTab {
      @include fun-active(2);
    }
  }
  .libraryContent{
    height: 100%;
    width: 1702px;
    margin-left: 160px;
    > section {
      height: 100%;
    }
  }
}
</style>
